// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Container } from './container';
import { Component } from './component';
import { render } from './common';

/**
 * @class Jsw.Pathbar
 * @extends Jsw.Container
 *
 * Example usage:
 *
 *     @example
 *     new Jsw.Pathbar({
 *         renderTo: document.body,
 *         cls: 'pathbar',
 *         items: [{
 *             componentType: 'Jsw.Pathbar.Item',
 *             title: 'Home',
 *         }, {
 *             componentType: 'Jsw.Pathbar.Item',
 *             title: 'Domains',
 *         }, {
 *             componentType: 'Jsw.Pathbar.Item',
 *             title: 'plesk.com',
 *         }, {
 *             componentType: 'Jsw.Pathbar.Item',
 *             title: 'PHP Settings',
 *         }],
 *     });
 */
export const Pathbar = Class.create(Container, {
    _initConfiguration($super, config) {
        $super(config);

        this._contentAreaId = `${this._id}-content-area`;
    },

    _initComponentElement($super) {
        if ($(this._id)) {
            this._applyTargetId = this._id;
            $super();

            return;
        }

        $super();

        this._updateComponentElement(
            `<ul id="${this._contentAreaId}"></ul>`
        );
    },

    _renderItem(item) {
        const renderTargetId = `${this._id}-item-${item.getId()}`;
        $(this._contentAreaId).insert(`<li id="${renderTargetId}"></li>`);
        render($(renderTargetId), item);
        this._renderItemSuffix(item);
    },

    _renderItemSuffix(item) {
        const renderTargetId = `${this._id}-item-${item.getId()}`;
        $(renderTargetId).insert('<b>&gt;</b>');
    },
});

/**
 * @class Jsw.Pathbar.Item
 * @extends Jsw.Component
 */
Pathbar.Item = Class.create(Component, {
    /**
     * @cfg {String} title
     */
    /**
     * @cfg {String} href
     */

    _initConfiguration($super, config) {
        $super(config);

        this._title = this._getConfigParam('title', '');
        this._href = this._getConfigParam('href', '');
    },

    _initComponentElement($super) {
        $super();

        this._componentElement = new Element('a', {
            href: this._href,
        }).update(`<span>${this._title}</span>`);
    },

    getHref() {
        return this._href;
    },
});

/**
 * @class Jsw.Pathbar.SimpleItem
 * @extends Jsw.Component
 */
Pathbar.SimpleItem = Class.create(Component, {
    /**
     * @cfg {String} title
     */

    _initConfiguration($super, config) {
        $super(config);

        this._title = this._getConfigParam('title', '');
    },

    _initComponentElement($super) {
        $super();

        this._componentElement = new Element('span');
        this._componentElement.update(this._title);
    },
});



// WEBPACK FOOTER //
// ./jsw/pathbar.js